import React, { createContext, useContext, useEffect, useState } from 'react';
import apiClient from '../../services/api';
import { getMediaBaseUrl, setMediaBaseUrl } from '../../constants/images';

const MediaConfigContext = createContext(getMediaBaseUrl());

/**
 * Loads CloudFront vs S3 public origin from the backend so image URLs
 * follow server config without a frontend rebuild.
 */
export function MediaConfigProvider({ children }: { children: React.ReactNode }) {
  const [mediaBaseUrl, setBase] = useState(getMediaBaseUrl());

  useEffect(() => {
    let cancelled = false;
    apiClient
      .get('/api/media/config')
      .then((response) => {
        const url = response?.data?.mediaBaseUrl as string | undefined;
        const delivery = String(response?.data?.delivery || '').toLowerCase();
        if (cancelled || !url) {
          return;
        }
        // A misconfigured backend returning S3 must not wipe the CDN origin.
        const forceS3 = (process.env.REACT_APP_MEDIA_CDN || '').trim().toLowerCase() === 's3';
        if (delivery !== 'cloudfront' && !forceS3) {
          return;
        }
        setMediaBaseUrl(url);
        setBase(getMediaBaseUrl());
      })
      .catch(() => {
        // Keep build-time / S3 default when the API is unreachable.
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return <MediaConfigContext.Provider value={mediaBaseUrl}>{children}</MediaConfigContext.Provider>;
}

export function useMediaBaseUrl(): string {
  return useContext(MediaConfigContext);
}

export default MediaConfigProvider;
